import React from 'react';
import { motion } from 'framer-motion';
import { Bell } from 'lucide-react';
import { Button } from '../ui';
import UserMenu from './UserMenu';

const TopBar: React.FC = () => {
  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="bg-slate-800 border-b border-slate-700 shadow-xl px-6 py-5"
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xl text-slate-300 font-semibold tracking-wide">Content. Analytics. Partnerships.</p>
        </div>

        <div className="flex items-center space-x-4">
          <Button
            variant="ghost"
            size="sm"
            icon={<Bell className="h-4 w-4" />}
            className="text-slate-300 hover:text-white hover:bg-slate-700"
          />
          <UserMenu />
        </div>
      </div>
    </motion.header>
  );
};

export default TopBar;